@for (item of residencesForm.controls; track item; let i = $index) {
  <div [formGroup]="item">
    @if (reference$ | async; as countries) {
      <div class="row">
        <pr-input-column label="Pays " [derrors]="derrors">
          <mat-select formControlName="country">
            @for (country of countries; track country) {
              <mat-option [value]="country.id">
                {{ country.value }}
              </mat-option>
            }
          </mat-select>
        </pr-input-column>
        <pr-input-column
          label="Numéro d'Identification Fiscale (NIF)"
          [derrors]="derrors"
        >
          <input
            placeholder="Exemple : L5555555L"
            formControlName="nif"
            type="text"
          />
        </pr-input-column>
        @if (residencesForm.length > 1) {
          @if (residencesForm?.controls[i]?.get('country')?.value) {
            <pr-button-confirm
              class="confirm"
              display="danger"
              clazz="pr-toolbar-button last"
              icon="delete_outline"
              title="Suppression"
              comment="Toute suppression est définitve, les données seront perdues."
              labelConfirm="Supprimer"
              labelCancel="Annuler"
              (onConfirm)="deleteFields(i)"
            >
              Êtes-vous sûr(e) de vouloir supprimer cette
              <em>“ résidence fiscale ”</em>
            </pr-button-confirm>
          } @else {
            <pr-button
              class="confirm"
              display="danger"
              clazz="pr-toolbar-button last"
              icon="delete_outline"
              (onClick)="deleteFields(i)"
            ></pr-button>
          }
        }
      </div>
    }
  </div>
}

<pr-button-add
  type="button"
  display="neutral"
  (click)="addFields()"
  label="Ajouter une résidence fiscale"
  rightIcon="+"
>
</pr-button-add>
